import Translator from 'components/ErrorTranslator';
import * as Yup from 'yup';
import 'config/yupExtensions';

export const STRING = (isMandatory: boolean) => Yup.string().isMandatory(isMandatory);

export const STRING_NULLABLE = (isMandatory: boolean) =>
  Yup.string().nullable().isMandatory(isMandatory);

export const INT = (isMandatory: boolean) =>
  Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .isMandatory(isMandatory);

export const BOOL = (isMandatory: boolean) => Yup.boolean().isMandatory(isMandatory);

export const EMAIL = (isMandatory: boolean, tKey: string) =>
  Yup.string()
    .isMandatory(isMandatory)
    .email(Translator(tKey, 'Bad format (e.g. john.doe@pluxee.com)'));

export const STRING_MIN_CHARS = (
  tKey: string = 'global_texts.validations.length_validation',
  minChars: number = 3,
) =>
  Yup.string()
    .nullable()
    .transform((o, c) => (o === '' ? null : c))
    .min(minChars, Translator(tKey, 'Enter at least 3 characters'));

export const NO_REGEXP_STRING_MIN_CHARS = () =>
  STRING_MIN_CHARS().matches(/^[a-zA-Z0-9À-ž\-\/:_,. ]+$/, {
    message: Translator(
      'global_texts.validations.no_regexp_validation',
      'Bad format, only numbers and characters with diacritics',
    ),
    excludeEmptyString: true,
  });
